import _ from 'lodash'
import moment from 'moment'

import { createSelector } from 'reselect'

import { RootState } from 'core/reducers'

import {
  AddAdministrationFormValues,
} from 'modals/Administrations/AddAdministrationModal/components/AddAdministrationModalForm'
import {
  AddEmergencyDoseFormValues,
} from 'modals/Administrations/AddEmergencyDoseModal/components/AddEmergencyDoseModalForm'
import { MEDICATION_DETAILS_TYPE } from 'services/medicationForms/constants'

import { addMillisecondsFromMidnight, millisecondsFromMidnight } from 'utils/date'

import { DEFAULT_DATE_FORMAT } from 'constants/date'
import { Administration, EmergencyDose } from '../models'
import { ADMINISTRATION_STATUSES, ADMINISTRATION_TYPE } from '../constants'

export const getAdministrationsSelector = (state: RootState) => state.administrations

export const getAdministrationsSingleSelector = createSelector(
  [getAdministrationsSelector],
  (state) => state.single.data,
)

export const getBody = (fields: AddAdministrationFormValues): Administration => {
  if (!fields) {
    return null
  }

  const {
    otherNotes,
    timeOfAdministration,
  } = fields

  return {
    otherNotes,
    status: ADMINISTRATION_STATUSES.ADMINISTERED,
    takenAt: addMillisecondsFromMidnight(millisecondsFromMidnight(timeOfAdministration), new Date())
      .utc().format('YYYY-MM-DD HH:mm:ss'),
    type: ADMINISTRATION_TYPE.SCHEDULED,
  }
}

export const getCreateBody = (fields: AddEmergencyDoseFormValues): EmergencyDose => {
  if (!fields) {
    return null
  }

  const {
    child,
    dose,
    expiryDate,
    medication,
    methodOfAdministration,
    otherNotes,
    parent,
    reason,
    sideEffects,
    takenAt,
    timeOfAdministration,
    wasParentContacted,
  } = fields

  return {
    child: {
      id: child?.value,
    },
    contactedParent: wasParentContacted ? {
      id: parent?.value,
    } : undefined,
    medicationDetails: {
      dose,
      expiryDate: expiryDate ? moment(expiryDate).format(DEFAULT_DATE_FORMAT) : undefined,
      medication,
      methodOfAdministration,
      reason,
      sideEffects,
      type: MEDICATION_DETAILS_TYPE.EMERGENCY,
    },
    otherNotes,
    status: ADMINISTRATION_STATUSES.ADMINISTERED,
    takenAt: addMillisecondsFromMidnight(millisecondsFromMidnight(timeOfAdministration), takenAt)
      .utc().format('YYYY-MM-DD HH:mm:ss'),
    type: ADMINISTRATION_TYPE.EMERGENCY,
    wasParentContacted,
  }
}

export const getExistingSignatureBody = (administration: Administration) => {
  const { signatures } = administration

  return _.map(signatures, ({
    id,
    owner,
    signature,
    type,
  }) => ({
    id,
    owner: {
      id: owner.id,
    },
    signature: {
      mimeType: signature.mimeType,
      size: signature.size,
      url: signature.url,
    },
    signedDigitally: true,
    type,
  }))
}
